module.exports = [{"id":1,"symbol":"€"},{"id":3,"symbol":"US$"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/currencies.json
// module id = 70
// module chunks = 0